module.exports = __webpack_public_path__ + "assets/img/spinning-wine.799c0d3e.png";